/**
 * 🔧 Configuración de Edge Functions
 * 
 * Centraliza todos los nombres de Edge Functions para:
 * - Evitar typos
 * - Facilitar refactoring
 * - Mantener consistencia
 */

/**
 * Nombres de Edge Functions del sistema
 * Usa kebab-case para consistencia con Supabase
 */
export const EDGE_FUNCTIONS = {
  INVITE_CUSTOMER_PORTAL: 'invite-customer-portal',
  // Super Admin
  ADMIN_LOGIN_AS_TENANT: 'admin-login-as-tenant',
  VALIDATE_ADMIN_LOGIN_TOKEN: 'validate-admin-login-token',
  
  // Usuarios
  CREATE_USER: 'create-user',
  REMOVE_TENANT_MEMBER: 'remove-tenant-member',
  
  // Documentos (DNI/RUC)
  CONSULTA_DOCUMENTO: 'consulta-documento',
  
  // Geocoding (si se usa Edge Function)
  REVERSE_GEOCODE: 'reverse-geocode',

  // Dominios personalizados (Cloudflare for SaaS). El CRUD + verificación de cert
  // vive en `manage-tenant-domain` (actions add/status/remove, invocada por
  // nombre). VERIFY_DNS y ADD_VERCEL_DOMAIN (era Vercel) se eliminaron: cero
  // consumidores y sus edge functions fueron dadas de baja.
  LOOKUP_DNS: 'lookup-dns',
  LOOKUP_DOMAIN_REGISTRAR: 'lookup-domain-registrar',
} as const;
